import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { hotSearchDataProvider } from './dataProvider';

// 注册 hotSearching 模块的数据提供者
export function initHotSearchDataProvider() {
  registerModuleDataProvider('hotSearching', hotSearchDataProvider);
}

// 自动初始化
initHotSearchDataProvider();





